module.exports = __webpack_public_path__ + "static/media/maximize-gray.822184ba.svg";